import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import LoginScreen from "../views/public/Login/LoginScreen";
import RegisterScreen from "../views/public/Register/RegisterScreen";
import firebase from "firebase/app";
import { useDispatch, useSelector } from "react-redux";
import HomeScreen from "../views/Home/HomeScreen";
import ProductScreen from "../views/Product/ProductScreen";
import ComparingCart from "../views/Cart/ComparingCart";
import CategoryScreen from "../views/Category/CategoryScreen";
import SuperMarkets from "../views/SuperMarkets/SuperMarkets";
import Favorites from "../views/Favorites/Favorites";
import Notifications from "../views/Notifications/Notifications";
import Profile   from "../views/Profile/Profile";
import PhoneLogin from "../views/public/Login/PhoneLogin";
import ComparesListScreen from "../views/ComparesList/ComparesListScreen";
import OffersScreen from "../views/Offers/OffersScreen";
import OfferDetails from "../views/Offers/OfferDetails";
import ContactUsScreen from "../views/ContactUs/ContactUsScreen";
import PrivacyPolicyScreen from "../views/public/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "../views/public/TermsAndConditions/TermsAndConditions";
import CustomerSupportScreen from "../views/ContactUs/CustomerSupportScreen";
import StoreScreen from "../views/StoreScreen/StoreScreen";
import ForgetPassword from "../views/public/ForgetPassword/ForgetPassword";
const Navigation = () => {
  const userInfo = useSelector((state) => state.auth.user);
  const currentUser = firebase.auth().currentUser;
  useEffect(()=>{
    console.log("user info : ", userInfo);
    const currentPath =window.location.pathname;
    console.log("currentPath : ",currentPath)
    if((!userInfo || userInfo ===null) &&(currentPath!="/" && currentPath !="/login" &&currentPath!='/register'&&currentPath!='/phoneLogin' &&currentPath!='/privacy-policy'&&currentPath!="/terms-conditions" &&currentPath!="") ){
    window.location.href = "/";}
  },[userInfo])

  return userInfo && userInfo!=null? (
    <Switch>
      <Route exact path={["", "/", "/home"]}>
        <HomeScreen />
      </Route>
      <Route exact path={"/product/:id"} >
        <ProductScreen />
      </Route>
      <Route exact path={"/compares-list"}>
        <ComparesListScreen />
      </Route>
      <Route exact path={"/offers"}>
        <OffersScreen />
      </Route>
      <Route exact path={"/offer-details/:id"} >
        <OfferDetails />
      </Route>
      <Route exact path={["/comparing-cart", "/comparing-cart/:id"]}>
        <ComparingCart />
      </Route>
      <Route exact path={"/categories/:id"}>
        <CategoryScreen />
      </Route>
      <Route exact path={"/store/:id"}>
        <StoreScreen />
      </Route>
      <Route exact path={"/stores"}>
        <SuperMarkets />
      </Route>
      <Route exact path={"/contact-us"}>
        <ContactUsScreen />
      </Route>
      <Route exact path={"/contact-us-support"}>
        <CustomerSupportScreen />
      </Route>
      <Route exact path={"/favorites"}>
        <Favorites/>
      </Route>
      <Route exact path={"/notifications"}>
        <Notifications/>
      </Route>
      <Route exact path={"/profile"}>
        <Profile/>
      </Route>
    </Switch>
  ) : (
    <Switch>
      <Route exact path={["", "/", "/login"]}>
        <LoginScreen />
      </Route>
      <Route exact path={"/phoneLogin"}>
        <PhoneLogin />
      </Route>
      <Route exact path={"/register"}>
        <RegisterScreen />
      </Route>
      <Route exact path={"/privacy-policy"}>
        <PrivacyPolicyScreen />
      </Route>
      <Route exact path={"/terms-conditions"}>
        <TermsAndConditions />
      </Route>
      <Route exact path={"/reset-password"}>
        <ForgetPassword />
      </Route>
    </Switch>
  );
};

export default Navigation;
